export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1756312177990-d771bfeaa030?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGRyaW5raW5nJTIwd2F0ZXIlMjBraXRjaGVufGVufDB8fHx8MTc5MDk1MjY5Nnww&ixlib=rb-4.1.0&q=85",
  glass: "https://images.unsplash.com/photo-1623266631647-6fba4a497be6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGhvbGRpbmclMjBnbGFzcyUyMHdhdGVyJTIwc3VubGlnaHR8ZW58MHx8fHwxNzkwOTUyNjgxfDA&ixlib=rb-4.1.0&q=85",
  kitchen: "https://images.pexels.com/photos/9869382/pexels-photo-9869382.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  shower: "https://images.pexels.com/photos/5849394/pexels-photo-5849394.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  laundry: "https://images.unsplash.com/photo-1724847885015-be191f1a47ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxmcmVzaCUyMGZvbGRlZCUyMHdoaXRlJTIwdG93ZWxzfGVufDB8fHx8MTc5MDk1MjY4MXww&ixlib=rb-4.1.0&q=85",
  dishes: "https://images.unsplash.com/photo-1736390755053-f57997f7931b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdpbmUlMjBnbGFzc2VzJTIwZGlzaHdhc2hlcnxlbnwwfHx8fDE3OTA5NTI2ODF8MA&ixlib=rb-4.1.0&q=85",
  consult: "https://images.unsplash.com/photo-1758523417185-5d46089b870a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxwZW9wbGUlMjBsb29raW5nJTIwYXQlMjB0YWJsZXQlMjBraXRjaGVufGVufDB8fHx8MTc5MDk1MjY4MXww&ixlib=rb-4.1.0&q=85",
};

export const CITY_NAMES = [
  "Oklahoma City", "Tulsa", "Broken Arrow", "Bixby", "Jenks",
  "Owasso", "Edmond", "Norman", "Yukon", "Moore",
];

export const WATER_SOURCES = [
  { value: "city", label: "City / Municipal Water" },
  { value: "well", label: "Private Well Water" },
  { value: "not_sure", label: "Not Sure" },
];

export const CONCERNS = [
  { value: "hard_water", label: "Hard Water / Scale / Spots" },
  { value: "taste_odor", label: "Taste, Odor & Chlorine" },
  { value: "skin_hair", label: "Dry Skin / Hair" },
  { value: "spots_residue", label: "Spots & Residue on Dishes" },
  { value: "appliances", label: "Appliance & Pipe Protection" },
  { value: "drinking_water", label: "Drinking Water Quality" },
  { value: "other", label: "Comprehensive Whole-Home Check" },
];

export const CALL_TIMES = [
  { value: "anytime", label: "Anytime" },
  { value: "morning", label: "Morning (8 AM – 12 PM)" },
  { value: "afternoon", label: "Afternoon (12 – 5 PM)" },
  { value: "evening", label: "Evening (5 – 8 PM)" },
];

export const TESTS = [
  {
    icon: "Gem",
    title: "Water Hardness (Grains Per Gallon)",
    text: "Measures dissolved calcium and magnesium. Reveals why soap won't lather and why scale builds on heating elements.",
  },
  {
    icon: "FlaskConical",
    title: "Chlorine & Chloramines",
    text: "Identifies municipal disinfection chemical levels that cause pool-like odors, dry-feeling skin in showers, and bitter drinking taste.",
  },
  {
    icon: "Droplets",
    title: "Total Dissolved Solids (TDS)",
    text: "Measures the overall concentration of dissolved inorganic salts and organic matter floating unseen in your water supply.",
  },
  {
    icon: "Scale",
    title: "pH Balance (Acidity / Alkalinity)",
    text: "Low acidic pH can corrode copper pipes and cause blue-green fixture staining; high pH contributes to premature scaling.",
  },
  {
    icon: "Magnet",
    title: "Iron & Rust Particulates",
    text: "Common in well supplies and older city mains; causes yellow-orange discoloration on porcelain and laundry fabrics.",
  },
  {
    icon: "Wind",
    title: "Sulfur & Odor Compounds",
    text: "Detects hydrogen sulfide gas and organic compounds responsible for unpleasant swampy or rotten-egg tap smells.",
  },
];

export const STEPS = [
  { num: "01", title: "Schedule", text: "Pick a convenient 30-minute window for our specialist to visit your home.", tag: "Simple online form" },
  { num: "02", title: "Test", text: "We draw water directly from your tap and run live diagnostics at the kitchen sink.", tag: "6 distinct parameters" },
  { num: "03", title: "Understand", text: "We review your readings together and explain what is causing spots, scale, or odor.", tag: "Plain English answers" },
  { num: "04", title: "Recommend", text: "If conditioning is beneficial, we present right-sized options and exact all-inclusive costs.", tag: "No hard sales pitch" },
  { num: "05", title: "Decide", text: "You take your time to review the findings. No expiration dates on our written estimates.", tag: "On your schedule" },
];

export const PRICING = [
  {
    label: "Complete Dual Conditioning",
    range: "$6,500 – $8,500",
    sub: "Whole-home softener + multi-stage filtration",
    points: [
      "Total protection: scale softening plus chemical/chloramine removal",
      "Sized for 3-5 bathroom homes and active families",
      "Dedicated under-sink high-purity drinking system included",
    ],
    featured: true,
  },
];

export const TESTIMONIALS = [
  {
    quote: "The water test was eye-opening. We had no idea our Edmond water was running 14 grains of hardness. No pressure at all during the visit, just clear explanations.",
    name: "Andrew - Homeowner in Edmond, OK",
  },
  {
    quote: "Our black bathroom fixtures in Broken Arrow had constant chalky buildup. Whitestone explained why our chloramines needed specific filtration. Outstanding experience.",
    name: "A.C. - Homeowner in Broken Arrow, OK",
  },
  {
    quote: "We were skeptical after having another company try to hard-close us for $12k in the first 10 minutes. Whitestone was completely educational and calm.",
    name: "Susan - Homeowner in Nichols Hills, OK",
  },
];

export const FAQS = [
  {
    q: "Is Oklahoma City water hard?",
    a: "Yes, most homeowners in the OKC metro experience moderately hard to hard water. The city's supply comes from surface lakes like Hefner, Overholser, and Draper, blended with groundwater, and hardness levels can shift seasonally. The only way to know your home's exact level is a test at your tap — which is what our free analysis measures in grains per gallon.",
  },
  {
    q: "Is Tulsa water hard?",
    a: "Tulsa's water, drawn primarily from Spavinaw and Eucha lakes, is generally considered moderately hard. Many Tulsa-area homeowners also notice taste and odor from chloramine, the disinfectant the city uses. Hardness varies by neighborhood and season, so an in-home test gives you a precise answer for your address.",
  },
  {
    q: "What's the difference between hard water and contaminated water?",
    a: "Hard water contains dissolved calcium and magnesium — minerals that affect how water performs but are not a health hazard at typical levels. Contamination refers to substances that shouldn't be in water at all. Hard water is a quality and comfort issue; contamination is a safety issue. City treatment handles safety; hardness is left for the homeowner to deal with.",
  },
  {
    q: "Do I need a water softener if my city water is safe to drink?",
    a: "Possibly. 'Safe to drink' means the water meets federal health standards when it leaves the treatment plant — it says nothing about hardness, chlorine taste, or scale buildup. If you're seeing spots on glassware, scale on fixtures, or feeling dry after showers, those are hardness symptoms a softener addresses. A test tells you whether your water actually warrants one.",
  },
  {
    q: "What does a whole-house water filter remove?",
    a: "It depends on the media inside. Catalytic carbon targets chlorine, chloramine, and many chemical tastes and odors. Sediment stages catch rust, sand, and fine particles. Specialty media can address iron and sulfur. No single filter removes everything — which is why we test first and match the media to what's actually in your water.",
  },
  {
    q: "What does a water softener actually do?",
    a: "A softener uses ion exchange to remove hardness minerals (calcium and magnesium) from your water. The result is water that lathers easily, rinses clean, and doesn't deposit scale inside pipes, water heaters, and appliances. It does not filter chemicals or improve taste on its own.",
  },
  {
    q: "What's the difference between a water filter and a water softener?",
    a: "Softening addresses hardness minerals — the scale, spots, and soap problems. Filtration addresses unwanted substances like chlorine, chloramine, sediment, or taste and odor compounds. They solve different problems, and many Oklahoma homes benefit from both working together. Your water test determines which — or whether you need either.",
  },
  {
    q: "How much does a whole-home water conditioning system cost?",
    a: "Most Whitestone homeowners invest between $119 and $145 per month, depending on the home's water needs, selected conditioning, approved credit, and financing terms. A complete solution typically combines whole-home water conditioning, multi-stage filtration and high-purity drinking water at the kitchen sink. Your home's water source, water quality, household size and usage all influence the right setup — we test first and show you the options in writing. Financing is subject to approval; terms and conditions apply.",
  },
  {
    q: "How long does installation take?",
    a: "Most whole-home installations are completed in a single day, typically 4 to 8 hours depending on your plumbing layout. The system is installed where the main water line enters your home — usually a garage, utility room, or basement loop — so equipment stays out of your living space.",
  },
  {
    q: "Does whole-home filtration require salt?",
    a: "No. Salt is used only by ion-exchange water softeners to regenerate their resin. Filtration systems using carbon or other media don't use salt at all. If your home needs both softening and filtration, only the softener will use salt — and modern high-efficiency units use far less than older designs.",
  },
  {
    q: "Does filtered water taste better?",
    a: "Most homeowners notice an immediate difference when chlorine or chloramine is removed — that's the 'pool water' taste in many city supplies. Whether filtered water tastes better to you depends on what's in your water to begin with, which is exactly what the free analysis identifies before you spend anything.",
  },
  {
    q: "Why does my water smell like chlorine?",
    a: "Because it contains chlorine (or chloramine) — your city adds it as a disinfectant to keep water safe as it travels through miles of pipe to your home. Levels can rise seasonally or after main breaks. It's doing an important job, but it doesn't need to stay in the water you drink and bathe in. Carbon filtration removes it at the point of entry.",
  },
  {
    q: "Why does my shower leave white spots?",
    a: "Those white spots are mineral scale — calcium and magnesium left behind when hard water evaporates. The same process happening on your shower glass is also happening inside your water heater, dishwasher, and pipes. A hardness test shows exactly how much mineral your water carries.",
  },
  {
    q: "Why does my skin feel dry after showering?",
    a: "Hard water minerals react with soap to form a residue that's difficult to rinse off skin and hair, and chlorine can strip natural oils. Many homeowners describe tight, itchy skin and dull hair after showering in hard, chlorinated water. Softening and filtration together address both causes. If you have a persistent skin condition, that's a conversation for your doctor — a water conditioner isn't a medical solution.",
  },
  {
    q: "Why do my dishes have spots after washing?",
    a: "Spots and cloudy film on glassware are mineral deposits from hard water, left behind as the rinse water dries. Harder water also prevents detergent from working fully, which makes the film worse. A softener eliminates the mineral content so dishes dry clear — and your dishwasher's heating element stays cleaner too.",
  },
  {
    q: "Can water conditioning help protect appliances?",
    a: "Yes. Scale from hard water builds up on heating elements and inside valves, forcing water heaters, dishwashers, and washing machines to work harder. Removing hardness minerals gives these appliances a better operating environment. We won't quote you invented lifespan percentages — but scale prevention is straightforward physics, and manufacturers acknowledge hardness as a factor in appliance wear.",
  },
  {
    q: "Do I need a reverse-osmosis drinking-water system?",
    a: "Only if you want the highest-purity drinking water at a dedicated tap. RO systems remove a very broad range of dissolved substances, far beyond what carbon filtration handles. Many families pair whole-home conditioning (for bathing, laundry, and appliances) with a small under-sink RO unit for drinking and cooking. Your test results and priorities determine whether it makes sense.",
  },
  {
    q: "Is bottled water better than filtered tap water?",
    a: "Bottled water costs far more per gallon over time, creates ongoing plastic waste, and its quality varies by brand — some is simply filtered municipal water. A properly matched home filtration setup gives you high-quality drinking water at your tap for a fraction of the long-term cost, with no hauling or recycling.",
  },
  {
    q: "How often does a water conditioning system need maintenance?",
    a: "Softeners need salt refills — typically every few weeks to months depending on water use — and an occasional checkup. Filtration media and cartridges need replacement on schedules ranging from months to years depending on the technology and your water conditions. We explain the exact maintenance schedule for any system we recommend, before you decide.",
  },
  {
    q: "What happens during a Whitestone water analysis?",
    a: "A specialist visits your home at a time you choose, draws water from your tap, and runs live tests at your kitchen sink — hardness, chlorine/chloramine, TDS, pH, iron, and other relevant characteristics. The visit takes 30 to 45 minutes. We explain every reading in plain English, discuss what you're experiencing, and only then talk through options if conditioning makes sense. No fee, no obligation.",
  },
];

export const CITIES = [
  {
    slug: "oklahoma-city",
    name: "Oklahoma City",
    region: "Central Oklahoma",
    headline: "Surface lakes, seasonal swings, and stubborn hardness",
    intro: "Oklahoma City's drinking water is drawn primarily from Lake Hefner, Lake Overholser, and Lake Draper, blended with groundwater. Surface supplies like these change with the seasons — algae activity in warm months, turnover in fall — and the city adjusts treatment to match. That means taste, odor, and chlorine levels can shift through the year even though the water meets safety standards.",
    issues: [
      "Moderate-to-high hardness that scales fixtures, water heaters, and glass shower doors",
      "Noticeable chlorine taste or odor, especially during seasonal treatment changes",
      "Occasional earthy or musty notes tied to seasonal algae activity in source lakes",
      "Spots and film on dishes and glassware that no detergent seems to fix",
    ],
    testFor: ["Hardness (grains per gallon)", "Chlorine level", "Total dissolved solids", "pH balance"],
    beforeYouBuy: "OKC water varies by neighborhood and season. Before choosing any system, test at your own tap — a home near Lake Hefner can read differently than one on the south side. Know your hardness number and chlorine level first, then size equipment to your actual water, not a citywide average.",
  },
  {
    slug: "tulsa",
    name: "Tulsa",
    region: "Green Country",
    headline: "Quality source lakes — with chloramine and hardness to manage",
    intro: "Tulsa's supply comes mainly from Spavinaw and Eucha lakes, two well-regarded surface sources in the Ozark foothills. The city uses chloramine — a chlorine-ammonia compound — for secondary disinfection. Chloramine is stable and effective, but it's also harder to remove than plain chlorine and won't come out with a basic big-box carbon filter.",
    issues: [
      "Chloramine taste and odor that standard pitcher filters don't fully remove",
      "Moderate hardness that leaves scale on fixtures and spots on glassware",
      "Dry-feeling skin and hair after showering in chloraminated water",
      "Vaporized disinfectant odor noticeable during hot showers",
    ],
    testFor: ["Chloramine vs. chlorine levels", "Hardness (grains per gallon)", "Total dissolved solids", "pH balance"],
    beforeYouBuy: "In Tulsa, the key question is chloramine. Effective removal requires catalytic carbon media designed for it — generic carbon filters exhaust quickly. A proper test distinguishes chloramine from chlorine so the filtration is matched to your actual supply.",
  },
  {
    slug: "broken-arrow",
    name: "Broken Arrow",
    region: "Tulsa Metro",
    headline: "Newer homes, municipal supply — and the same chloramine question",
    intro: "Most of Broken Arrow receives treated water through the Tulsa metro system, which means chloramine disinfection and moderate hardness are the common themes. With so much newer construction, many homeowners first notice water quality through spots on new black or brushed fixtures and film on glass shower enclosures.",
    issues: [
      "Chalky buildup and spots that show aggressively on modern dark fixtures",
      "Chloramine taste in drinking water and ice",
      "Scale accumulation inside newer tankless water heaters",
      "Soap scum on glass shower doors in hard-water neighborhoods",
    ],
    testFor: ["Chloramine levels", "Hardness (grains per gallon)", "Total dissolved solids", "Sediment"],
    beforeYouBuy: "Broken Arrow homes on the metro supply share similar water, but hardness still varies. If you have a tankless water heater, ask about scale — manufacturers often require softened water to keep warranties valid. Test first so conditioning is sized to your home's actual readings.",
  },
  {
    slug: "bixby",
    name: "Bixby",
    region: "Tulsa Metro / Arkansas River Corridor",
    headline: "Where city supply meets well country",
    intro: "Bixby straddles two worlds: neighborhoods on the Tulsa-area municipal supply and properties toward the Arkansas River corridor that rely on private wells. That mix means two Bixby homes a mile apart can have completely different water — chloramine and moderate hardness in town, iron and sulfur on well acreage.",
    issues: [
      "Municipal areas: chloramine taste and moderate hardness",
      "Well properties: orange iron staining on porcelain and laundry",
      "Well properties: rotten-egg sulfur odor, especially in hot water",
      "Variable pH in well water that can affect copper plumbing",
    ],
    testFor: ["Water source confirmation", "Hardness and chloramine (city) or iron, sulfur, and pH (well)", "Sediment", "Total dissolved solids"],
    beforeYouBuy: "The first question in Bixby isn't which system — it's which water. City and well supplies need fundamentally different conditioning, and guessing wrong is expensive. The free analysis identifies your actual conditions before any equipment is discussed.",
  },
  {
    slug: "jenks",
    name: "Jenks",
    region: "Tulsa Metro",
    headline: "River-town water with established and growing neighborhoods",
    intro: "Jenks draws from the Tulsa-area supply system, so chloramine disinfection and moderate hardness are the baseline. Established neighborhoods near the river have older service lines that can introduce sediment, while new developments on the south side see the scale and spotting common across the metro.",
    issues: [
      "Chloramine taste and odor in drinking water",
      "Hardness scale on fixtures, faucets, and shower glass",
      "Occasional sediment in older service areas",
      "Dry-feeling skin and hair, especially in winter",
    ],
    testFor: ["Chloramine levels", "Hardness (grains per gallon)", "Sediment", "pH balance"],
    beforeYouBuy: "Jenks homes range from mid-century builds to brand-new construction, and plumbing age affects what conditioning makes sense. A test plus a look at your actual plumbing layout beats any package deal — insist on both before committing to equipment.",
  },
  {
    slug: "owasso",
    name: "Owasso",
    region: "Tulsa Metro",
    headline: "Fast-growing neighborhoods, familiar water questions",
    intro: "Owasso's rapid growth means much of the housing stock is newer, and homeowners there tend to notice water quality first through appearance: spots on dishes, haze on glassware, scale on new fixtures. The city's supply includes treated surface and groundwater sources, with chloramine disinfection and moderate-to-noticeable hardness.",
    issues: [
      "Visible scale on new fixtures and appliances within the first years of ownership",
      "Chloramine taste affecting drinking water, coffee, and ice",
      "Stiff-feeling laundry and extra detergent use",
      "Spots and film on dishes straight out of the dishwasher",
    ],
    testFor: ["Hardness (grains per gallon)", "Chloramine levels", "Total dissolved solids", "Sediment"],
    beforeYouBuy: "In a newer Owasso home, scale is already at work inside the water heater and dishwasher even when you can't see it yet. Testing gives you the hardness number that determines whether a softener, filtration, or both is the right-sized answer.",
  },
  {
    slug: "edmond",
    name: "Edmond",
    region: "Central Oklahoma",
    headline: "Groundwater-rich supply known for real hardness",
    intro: "Edmond's supply leans heavily on groundwater wells, including the Garber-Wellington aquifer, blended with surface water. Groundwater dissolves minerals as it moves through rock, and Edmond homeowners routinely deal with some of the more noticeable hardness in the metro — scale on fixtures, spots on glassware, and soap that won't lather.",
    issues: [
      "Hard water scale on faucets, showerheads, and glass enclosures",
      "White residue in kettles, coffee makers, and humidifiers",
      "Reduced water heater efficiency from internal scale buildup",
      "Dry-feeling skin and dull hair after showering",
    ],
    testFor: ["Hardness (grains per gallon)", "Total dissolved solids", "Chlorine level", "Iron (in some well-influenced areas)"],
    beforeYouBuy: "Edmond hardness can run high enough that an undersized softener regenerates constantly and wastes salt and water. The hardness reading from your test determines correct sizing — this is one city where guessing at equipment capacity genuinely costs money.",
  },
  {
    slug: "norman",
    name: "Norman",
    region: "Central Oklahoma",
    headline: "A blended supply that changes with the source mix",
    intro: "Norman blends surface water from Lake Thunderbird with groundwater wells, and the ratio shifts with demand and season. Homeowners can notice the difference — taste and odor change through the year, and hardness varies depending on how much groundwater is in the mix when it reaches your tap.",
    issues: [
      "Variable hardness as the surface/groundwater blend shifts seasonally",
      "Earthy taste notes during warm-season algae activity at the source lake",
      "Chlorine or chloramine odor depending on current treatment approach",
      "Scale and spotting consistent with moderate-to-hard water",
    ],
    testFor: ["Hardness (grains per gallon)", "Chlorine/chloramine levels", "Total dissolved solids", "pH balance"],
    beforeYouBuy: "Because Norman's blend changes, a single test is a snapshot — but it still tells you your home's hardness baseline and disinfectant situation, which drive equipment decisions more than seasonal taste swings. Test, understand, then decide.",
  },
  {
    slug: "yukon",
    name: "Yukon",
    region: "Canadian County",
    headline: "Groundwater country on the metro's western edge",
    intro: "Yukon relies substantially on groundwater wells, and groundwater in Canadian County carries the mineral signature of the rock it passes through — meaning hardness is the headline issue for most homeowners. Properties farther out toward rural Canadian County may be on private wells, where iron and sulfur join the list.",
    issues: [
      "Hard water scale on fixtures, water heaters, and appliances",
      "Spots and film on dishes and glassware",
      "Rural well properties: iron staining and sulfur odor",
      "Soap and shampoo that won't lather or rinse cleanly",
    ],
    testFor: ["Hardness (grains per gallon)", "Total dissolved solids", "Iron (well properties)", "Sulfur compounds (well properties)"],
    beforeYouBuy: "Yukon homes on city water mainly need the hardness question answered. If you're on a private well outside city service, the testing list grows — iron, sulfur, pH, and sediment all affect which conditioning setup makes sense. Either way, the test comes first.",
  },
  {
    slug: "moore",
    name: "Moore",
    region: "Central Oklahoma / OKC Metro",
    headline: "Metro supply with the hardness to prove it",
    intro: "Moore sits in the heart of the OKC metro and shares the region's surface-and-groundwater supply character: dependable safety, noticeable hardness, and disinfectant levels that change with the seasons. Many Moore homes were built or rebuilt in recent decades, and scale is often the first sign new homeowners notice.",
    issues: [
      "Moderate-to-hard water leaving scale on fixtures and shower glass",
      "Chlorine taste and odor in tap water and ice",
      "Film on dishes and reduced detergent performance",
      "Scale-related wear on water heaters over time",
    ],
    testFor: ["Hardness (grains per gallon)", "Chlorine level", "Total dissolved solids", "Sediment"],
    beforeYouBuy: "Moore water is typical of the central Oklahoma metro — which means the typical mistakes apply too: buying a softener sized for a national average instead of your actual hardness, or filtering for chlorine when your street's water calls for something else. A 20-minute test replaces assumptions with numbers.",
  },
];
